/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated';
import { ceilDependencies } from './dependenciesCeil.generated';
import { floorDependencies } from './dependenciesFloor.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createFix } from '../../factoriesAny.js';
export var fixDependencies = {
  ComplexDependencies: ComplexDependencies,
  ceilDependencies: ceilDependencies,
  floorDependencies: floorDependencies,
  typedDependencies: typedDependencies,
  createFix: createFix
};